export default __webpack_public_path__ + "static/media/video_template_landscape_nightlife_hd.f3f5fd2d.mp4";